import * as React from "react";
import IntlMessageFormat from "./auth-service-tools128.js";
import memoizeIntlConstructor from "./auth-service-tools129.js";
import { UnsupportedFormatterError } from "./auth-service-tools126.js";
import { invariant } from "./auth-service-tools130.js";

function filterProps(props, whitelist, defaults) {
  if (defaults === void 0) {
    defaults = {};
  }

  return whitelist.reduce(function (filtered, name) {
    if (name in props) {
      filtered[name] = props[name];
    } else if (name in defaults) {
      filtered[name] = defaults[name];
    }

    return filtered;
  }, {});
}

function invariantIntlContext(intl) {
  invariant(intl, "[React Intl] Could not find required `intl` object. <IntlProvider> needs to exist in the component ancestry.");
}

var defaultErrorHandler = function (error) {
  if (process.env.NODE_ENV !== "production") {
    console.error(error);
  }
};

var DEFAULT_INTL_CONFIG = {
  formats: {},
  messages: {},
  timeZone: void 0,
  textComponent: React.Fragment,
  defaultLocale: "en",
  defaultFormats: {},
  onError: defaultErrorHandler
};

function createIntlCache() {
  return {
    dateTime: {},
    number: {},
    message: {},
    relativeTime: {},
    pluralRules: {},
    list: {},
    displayNames: {}
  };
}

function createFormatters(cache) {
  if (cache === void 0) {
    cache = createIntlCache();
  }

  var RelativeTimeFormat = Intl.RelativeTimeFormat;
  var ListFormat = Intl.ListFormat;
  var DisplayNames = Intl.DisplayNames;
  return {
    getDateTimeFormat: memoizeIntlConstructor(Intl.DateTimeFormat, cache.dateTime),
    getNumberFormat: memoizeIntlConstructor(Intl.NumberFormat, cache.number),
    getMessageFormat: memoizeIntlConstructor(IntlMessageFormat, cache.message),
    getRelativeTimeFormat: memoizeIntlConstructor(RelativeTimeFormat, cache.relativeTime),
    getPluralRules: memoizeIntlConstructor(Intl.PluralRules, cache.pluralRules),
    getListFormat: memoizeIntlConstructor(ListFormat, cache.list),
    getDisplayNames: memoizeIntlConstructor(DisplayNames, cache.displayNames)
  };
}

function getNamedFormat(formats, type, name, onError) {
  var formatType = formats && formats[type];
  var format;

  if (formatType) {
    format = formatType[name];
  }

  if (format) {
    return format;
  }

  onError(new UnsupportedFormatterError("No " + type + " format named: " + name));
}

export { DEFAULT_INTL_CONFIG, createFormatters, createIntlCache, defaultErrorHandler, filterProps, getNamedFormat, invariantIntlContext };